import { ROUTES_NAME } from "../../../config/constants";
import { ACCESS_TOKEN } from "../../../constants";
import { authenticatedFetch } from "../../../util/authenticatedFetch";
import {
  CACHE_SYNC_ERROR,
  CACHE_SYNC_REQUEST,
  CACHE_SYNC_RESET,
  CACHE_SYNC_SUCCESS,
} from "./ActionType";

const readResponsePayload = async (response) => {
  if (typeof response.text === "function") {
    const text = await response.text();
    if (!text) return null;

    try {
      return JSON.parse(text);
    } catch (_error) {
      return { message: text };
    }
  }

  if (typeof response.json === "function") {
    try {
      return await response.json();
    } catch (_error) {
      return null;
    }
  }

  return null;
};

let requestSequence = 0;

const createRequestMeta = (shopId) => {
  const normalizedShopId = String(shopId);
  requestSequence += 1;

  return {
    shopId: normalizedShopId,
    requestId: `refreshPayPalCache:${normalizedShopId}:${Date.now()}:${requestSequence}`,
  };
};

export const cacheSyncForShop = (shopId) => {
  return async (dispatch) => {
    const meta = createRequestMeta(shopId);
    dispatch(cacheSyncRequest(meta));
    const url = `${
      process.env.REACT_APP_BACKEND_API_URL
    }${ROUTES_NAME.cacheSync(shopId)}`;
    try {
      const response = await authenticatedFetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN),
          "Content-Type": "application/json",
          Origin: `${process.env.REACT_APP_URL}`,
        },
      });
      const payload = await readResponsePayload(response);
      if (!response.ok) {
        const serverMessage =
          (typeof payload === "string" && payload) ||
          [payload?.message, payload?.error, payload?.detail].find(
            (value) => typeof value === "string" && value.trim()
          );
        throw new Error(
          serverMessage || `PayPal cache refresh failed (${response.status})`
        );
      }
      dispatch(cacheSyncSuccess(payload, meta));
      return { ok: true, payload };
    } catch (error) {
      const message = error?.message || "PayPal cache refresh failed";
      dispatch(cacheSyncError(message, meta));
      return { ok: false, error: message };
    }
  };
};

export const resetCacheSync = () => ({ type: CACHE_SYNC_RESET });

function cacheSyncRequest(meta) {
  return {
    type: CACHE_SYNC_REQUEST,
    meta,
  };
}

function cacheSyncSuccess(data, meta) {
  return {
    type: CACHE_SYNC_SUCCESS,
    payload: data,
    meta,
  };
}

function cacheSyncError(data, meta) {
  return {
    type: CACHE_SYNC_ERROR,
    payload: data,
    meta,
  };
}
